module.exports = __webpack_public_path__ + "img/Kc-Is-your-business-reflecting-your-vitality.51f2077e.png";